<template>
  <AddCourse />
</template>
<script>
import appConfig from '@/app.config'
import AddCourse from '../../../components/dadban/courses/AddCourse.vue'
export default {
  page: {
    title: 'ثبت دوره',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-courses',
  components: {
    AddCourse,
  },
}
</script>
